import React from 'react'
import { CardContainer_Props } from './interface'
import { Placeholder, RiverWrapper } from './GameBoardStyles'
import { Card } from '../card/Card'
import { CardWrapper } from '../card/CardStyles'
import { colors } from 'lib/colors'

export default function RiverContainer({
  cardsList,
  deal,
  dealOut,
  dealRiver,
  calculateDelay,
  showResult,
  winPositions,
  noAnimate,
  delay,
}: CardContainer_Props) {

  return (
    <RiverWrapper>
      {cardsList.slice(0, 3).map((card: any, id: number) => (
        <Placeholder key={id} zIndex={5 - id}>
          {deal && (
            <CardWrapper
              deal={deal}
              flipCard={false}
              dealOut={dealOut}
              delay={delay}
            >
              <Card
                noAnimate={noAnimate}
                card={card}
                deal={deal}
                animDelay={calculateDelay(id + 4)}
                background={
                  showResult && winPositions.slice(0, 3)[id] === '1'
                    ? colors.secondary
                    : colors.cardWhite
                }
              />
            </CardWrapper>
          )}
        </Placeholder>
      ))}
      {cardsList.slice(3, 5).map((card: any, id: number) => (
        <Placeholder key={id} zIndex={2 - id}>
          {noAnimate && card === 'X0'
            ? ''
            : dealRiver && (
                <CardWrapper
                  deal={deal}
                  flipCard={false}
                  dealOut={dealOut}
                  delay={delay}
                >
                  <Card
                    noAnimate={noAnimate}
                    card={card}
                    background={
                      showResult && winPositions.slice(3, 5)[id] === '1'
                        ? colors.secondary
                        : colors.cardWhite
                    }
                    deal={dealRiver}
                    animDelay={calculateDelay(id)}
                  />
                </CardWrapper>
              )}
        </Placeholder>
      ))}
    </RiverWrapper>
  )
}
